// extracted by mini-css-extract-plugin
export var button = "stDePlyl";
export var buttons = "-ilwDNcE";
export var tabletDown = "H-lRQLzF";
export var prompt = "yOY7LXV+";
export var promptText = "ufd0jAFX";